// historyReducer.js
const initialState = {
    queries: [] // SQL 쿼리 히스토리 배열
};

// 액션 타입
export const ADD_TO_HISTORY = 'ADD_TO_HISTORY';
export const CLEAR_HISTORY = 'CLEAR_HISTORY';
export const DELETE_HISTORY_ITEM = 'DELETE_HISTORY_ITEM';

// 액션 생성자
export const addToHistory = (historyItem) => ({
    type: ADD_TO_HISTORY,
    payload: historyItem
});

export const clearHistory = () => ({
    type: CLEAR_HISTORY
});

export const deleteHistoryItem = (timestamp) => ({
    type: DELETE_HISTORY_ITEM,
    payload: timestamp
});

// 리듀서
const historyReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TO_HISTORY:
            return {
                ...state,
                queries: [action.payload, ...state.queries].slice(0, 20) // 최대 20개 유지
            };
        case CLEAR_HISTORY:
            return {
                ...state,
                queries: []
            };
        case DELETE_HISTORY_ITEM:
            return {
                ...state,
                queries: state.queries.filter(query => query.timestamp !== action.payload)
            };
        default:
            return state;
    }
};

export default historyReducer;